module.exports = __webpack_public_path__ + "static/media/frank.f7a1db11.png";